import { Box, Paper } from '@mui/material';
import colors from '@sweep-io/sweep-design/dist/colors';
import { useReorderStepsCtx } from './ReorderStepsCtx';
import { Button, Typography } from '@sweep-io/sweep-design';
import { useReorderSteps } from './useReorderSteps';

const ReorderStepsControls = () => {
  const { deactivateReorderStepsMode, applyReorderSteps } = useReorderSteps();
  return (
    <Paper
      elevation={1}
      sx={{
        position: 'absolute',
        bottom: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        backgroundColor: colors.white,
        height: '72px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 12px',
        borderRadius: '4px',
        gap: '8px',
      }}
    >
      <Box marginRight="8px">
        <Typography variant="body" color={colors.grey[700]}>
          Click and drag steps to rearrange
        </Typography>
      </Box>
      <Button variant="outlined" size="small" onClick={deactivateReorderStepsMode}>
        Cancel and revert
      </Button>
      <Button variant="filled" size="small" onClick={applyReorderSteps}>
        Save
      </Button>
    </Paper>
  );
};

const ReorderStepsControlsWrapper = () => {
  const { reorderSteps } = useReorderStepsCtx();
  if (!reorderSteps) {
    return null;
  }
  return <ReorderStepsControls />;
};

export { ReorderStepsControlsWrapper as ReorderStepsControls };
